import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormLabel,
  OutlinedInput,
  InputBase,
} from "@mui/material";

export default class SimpleInputDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      GhiChu: props.defaultValue ? props.defaultValue : "",
    };
  }

  componentDidMount() {}
  //call khi user thay doi trang
  static getDerivedStateFromProps(nextProps, prevState) {
    return { open: nextProps.open };
  }
  render() {
    let tau = this.state.tauData;
    return (
      <Dialog
        open={this.props.open}
        onClose={() => {}}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {this.props.title ? this.props.title : "Thông báo"}
        </DialogTitle>
        <DialogContent>
          <div
            style={{
              minWidth: 450,
              minHeight: 30,
              padding: 5,
              fontSize: 10,
              wordWrap: "break-word",
            }}
          >
            <FormLabel
              sx={{ ml: 1, flex: 1 }}
              multiline
              fullWidth
            >
              {this.props.message}
            </FormLabel>
            <br />
            <OutlinedInput
              fullWidth
              autoFocus
              value={this.state.GhiChu}
              multiline
              onChange={(event) => {
                this.setState({ GhiChu: event.target.value });
                if (this.props.onChange) {
                  this.props.onChange(event.target.value);
                }
              }}
            />
          </div>
        </DialogContent>
        <DialogActions>
          {this.props.confirm ? (
            <Button
              onClick={() => {
                if (this.props.close) {
                  this.props.close(true, this.state.GhiChu);
                }
              }}
              variant="contained"
            >
              {this.props.OKRunning ? "SAVING..." : "OK"}
            </Button>
          ) : null}
          <Button
            onClick={() => {
              if (this.props.close) {
                this.props.close(false);
              }
            }}
            variant="contained"
          >
            {this.props.confirm ? "CANCEL" : "Thoát"}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}
